<template>
    <router-view />
</template>

<script>
export default {
    async created () {
        let response = await this.$http().get('booking/config')
        this.$store.state.meetings.teams = response.data.teams
        this.$store.state.meetings.salesAgents = response.data.salesAgents
        this.$store.state.meetings.bookingAgents = response.data.bookingAgents
        this.$store.state.meetings.bookingCampaigns = response.data.bookingCampaigns
        if (this.$store.state.main.access === 'tele') {
            if (this.$store.state.main.relogged) this.$store.state.meetings.salesAgent = this.$store.state.main.reloggedName
            else this.$store.state.meetings.salesAgent = this.$store.state.main.name
        }
    }
}
</script>